import React, { Fragment } from 'react';
import { BlogHelmet } from '../components/MoiPayHelmet';
import BlogComponent from '../components/blog/blog_component';

export default function Blog() {
  return (
    <Fragment>
      <BlogHelmet />
      <BlogComponent />
    </Fragment>
  );
} 